const columns = [
  {
    title: "Customer ID",
    key: "order",
    subkey: "user",
    subkey1: "_id",
  },
  {
    title: "Customer Name",
    key: "order",
    subkey: "user",
    subkey1: "full_name",
  },
  {
    title: "Order Number",
    key: "order",
    subkey: "_id",
  },
  {
    title: "Order Type",
    key: "order",
    subkey: "order_flow",
  },
  {
    title: "Order Placed Date & Time",
    key: "order",
    subkey: "created_at",
    date: true,
  },
  {
    title: "Promotion Discount",
    key: "order",
    subkey: "discount",
    float: true,
  },
  {
    title: "Total Order Amount",
    key: "order",
    subkey: "payment_details",
    subkey1: "total_paid",
    float: true,
  },
  {
    title: "Customer Payment Type",
    key: "order",
    subkey: "payment_details",
    subkey1: "is_cash",
    cashType: true,
    is_cash: true,
  },
  {
    title: "Supplier Name",
    key: "order",
    subkey: "supplier",
    subkey1: "full_name",
  },
  {
    title: "Pillvery Commission",
    key: "pillvery_commission",
    float: true,
  },
  {
    title: "Supplier Commission",
    key: "supplier_commission",
    float: true,
  },
  {
    title: "Payment Commission",
    key: "payment_commision",
    float: true,
  },
  {
    title: "Tax",
    key: "order",
    subkey: "tax",
    float: true,
  },
  {
    title: "Service Charge",
    key: "order",
    subkey: "delivery_details",
    subkey1: "fees",
    float: true,
  },
  {
    title: "Balance",
    key: "balance",
    subkey: "delivery_details",
    subkey1: "balance",
    float: true,
  },
  {
    title: "Transaction Status",
    key: "order",
    subkey: "status",
  },
];

export default columns;
